// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as React from "react";

function Info(Props) {
  return React.createElement("div", {
              id: "info"
            }, "Enter a block hash or number to bring up information on the block or press search for the most recent block");
}

var make = Info;

export {
  make ,
  
}
/* react Not a pure module */
